export default "__VITE_PUBLIC_ASSET__20224e9d__"